// @flow

import React from "react";
import classNames from "classnames";

import options from "../utils/options";
import SwitchButton from "../../switch-button";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./switch.scss";

export class SwitchWidget extends React.Component<SchemaTableWidgetProps<boolean>> {
  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    return (
      <div
        className={classNames("switch__container", {
          "switch__container--disabled": disabled,
        })}
      >
        <SwitchButton
          active={this.props.data}
          disabled={!this.props.active || disabled}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default SwitchWidget;
